import React from 'react'
import { AboutACIT, Footer, OurProgress, TopOfHomePage } from '../../Sections/Home'
import './Home.css'
const Home = () => {
  return (
    <>

    <TopOfHomePage/>
    <OurProgress/>
    <AboutACIT/>
    <Footer/>
    </>
  )
}

export default Home